import React from "react";
import { LanguageCode } from "../../amorg-common";
import { Label } from "../Label";
import { AmorgMenuContent } from "../amorgMenu";
import { AmorgMenuButton } from "../amorgMenu/AmorgMenuButton";
import { Flex } from "./FlexHelpers";

type LanguageSelectorProps = {
    availableLanguages:LanguageCode[],
    selectedLanguage:LanguageCode,
    onSelectedLanguageChange:(language:LanguageCode)=>void
}
export function LanguageSelector(props:LanguageSelectorProps):JSX.Element
{
    function getLangText(langCode:LanguageCode)
    {
        function assertHandlerNever(x: never): never {
            throw new Error("Unexpected language: " + x);
        }

        switch(langCode){
            case 'da': return 'Dansk';
            case 'en': return 'English';
            default: assertHandlerNever(langCode);
        }
    }

    function getLanguageMenuItem(languageCode:LanguageCode):AmorgMenuContent
    {
        return {
            type:'leadingContent',
            leadingContent:props.selectedLanguage===languageCode 
                ? { type:'icon', iconName:'actions_done'}
                : { type:'none'},
            primaryContent:{type:'text', text:getLangText(languageCode)},
            styleVariant:'default',
            onClick:()=>props.onSelectedLanguageChange(languageCode)
        }
    }

    return (
        <Flex flexDirection="row" alignItems="center">
            <Label>{getLangText(props.selectedLanguage)}</Label>
            <AmorgMenuButton
                icon='caret_caretDown'
                content={props.availableLanguages.map(al => getLanguageMenuItem(al))} />
        </Flex>
    );
}